var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C8.13401 5 5 8.13401 5 12C5 13.6589 5.57708 15.1831 6.54144 16.3826C7.44371 15.8531 8.49806 15.4597 9.641 15.2307C8.64616 14.503 8 13.327 8 12V11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11V12C16 13.327 15.3538 14.503 14.359 15.2307C15.5019 15.4597 16.5563 15.8531 17.4586 16.3826C18.4229 15.1831 19 13.6589 19 12C19 8.13401 15.866 5 12 5ZM12 19C10.5586 19 9.21896 18.5643 8.10556 17.8175C9.17621 17.3134 10.5159 17 12 17C13.4841 17 14.8238 17.3134 15.8944 17.8175C14.781 18.5643 13.4414 19 12 19ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM10 11C10 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11V12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12V11Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ab86f1c2.svg";
export { ForwardRef as ReactComponent };